var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "asterisk_1_",
    "data-name": "asterisk (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.826,
    height: 11.458,
    viewBox: "0 0 11.826 11.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "asterisk_1_2",
    "data-name": "asterisk (1)",
    d: "M86.826,81.087l-.841-2.444L82.017,80.3l.342-4.6H79.6l.315,4.494-4.073-1.682L75,80.956l4.178,1.156-2.917,3.469,2.208,1.472L80.834,83.4l2.339,3.758,2.234-1.5-2.812-3.416Z",
    transform: "translate(-75 -75.7)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.176aa5e03805c26fe5879a53833d4a01.svg";
export { ForwardRef as ReactComponent };